import styled from "styled-components";

export const LabelContainer = styled.div``;

export const SwitchContainer = styled.div<{
  $checked?: boolean;
  $screenSize: string;
  $hasDescription: boolean;
}>`
  display: ${(props) =>
    props.$screenSize === "regular" ? "flex" : "inline-block"};
  width: ${(props) =>
    props.$screenSize === "regular" ? "100%" : "fit-content"};
  ${(props) =>
    props.$screenSize === "regular" && "justify-content: space-between"};
  ${(props) => (!props.$hasDescription ? "align-items: center" : "")};
  user-select: none;

  &:focus-within {
    outline: none;
    background-color: var(--ons-color-white);
    > span {
      background-color: var(--ons-color-sun-yellow);
      span {
        background-color: var(--ons-color-black);
      }
      div {
        color: var(--ons-color-black);
      }
    }
  }

  &:hover {
    background-color: var(--ons-color-white);
    > span {
      background-color: ${(props) =>
        props.$checked
          ? "var(--ons-color-night-blue)"
          : "var(--ons-color-grey-15)"};
      span {
        background-color: ${(props) =>
          props.$checked
            ? "var(--ons-color-white)"
            : "var(--ons-color-ocean-blue)"};
      }
      div {
        color: ${(props) =>
          props.$checked
            ? "2px var(--ons-color-white)"
            : "2px var(--ons-color-ocean-blue)"};
      }
    }
  }

  &.switch-disabled {
    pointer-events: none;
    color: var(--ons-color-grey-35);
    opacity: 50%;
  }

  &.switch-view-only {
    pointer-events: none;

    > span {
      background-color: ${(props) =>
        props.$checked
          ? "rgb(from var(--ons-color-ocean-blue) r g b / 0.5)"
          : "var(--ons-color-white)"};
      span {
        background-color: ${(props) =>
          props.$checked
            ? "rgb(from var(--ons-color-white) r g b / 0.7)"
            : "rgb(from var(--ons-color-ocean-blue) r g b / 0.2)"};
      }
      div {
        color: var(--ons-color-black);
      }
    }
  }
`;

export const ToggleContainer = styled.span<{
  $checked?: boolean;
  $disabled?: boolean;
  $viewOnly?: boolean;
}>`
  display: inline-block;
  border: ${(props) =>
    props.$checked
      ? props.$viewOnly
        ? "2px solid rgb(from var(--ons-color-night-blue) r g b / 0.5)"
        : "2px solid var(--ons-color-night-blue)"
      : props.$viewOnly
        ? "2px solid rgb(from var(--ons-color-ocean-blue) r g b / 0.35)"
        : "2px solid var(--ons-color-ocean-blue)"};
  border-radius: 24px;
  height: 41px;
  width: 82px;
  min-width: 82px;
  background-color: ${(props) =>
    props.$checked ? "var(--ons-color-ocean-blue)" : "var(--ons-color-white)"};
  vertical-align: middle;
  font-weight: bold;
  color: ${(props) =>
    !props.$disabled
      ? props.$checked
        ? "var(--ons-color-white)"
        : "var(--ons-color-ocean-blue)"
      : "var(--ons-color-grey-35)"};
  font-size: 1rem;
  padding-top: 2px;
`;

export const ToggleInput = styled.input``;

export const ToggleCircle = styled.span<{ $checked?: boolean }>`
  display: inline-block;
  border-radius: 50%;
  height: 23px;
  width: 23px;
  background-color: ${(props) =>
    props.$checked
      ? "var(--ons-color-white)"
      : "rgb(from var(--ons-color-ocean-blue) r g b / 0.4)"};
  vertical-align: middle;
`;

export const ToggleLabel = styled.div<{ $checked?: boolean }>`
  display: inline-block;
  padding-left: ${(props) => (props.$checked ? "12px" : "9px")};
  padding-right: ${(props) => (props.$checked ? "9px" : "12px")};
  vertical-align: middle;
`;
